export interface TeamMember {
  name: string;
  title: string;
  languages: string[];
  /** RERA Agent (BRN) number, shown on the card when available. */
  reraAgentNo?: string;
  /** Studio headshot URL. */
  photo?: string;
  /** Optional per-agent WhatsApp number; falls back to the brand number. */
  whatsapp?: string;
}

/**
 * Team roster powering the "The People Behind Every Deal." section on the
 * homepage and About page (see HiveHomes_Website_Content.docx → Our Team).
 *
 * Left empty until the real names, titles, languages, RERA Agent numbers
 * and studio headshots are supplied — we never publish fabricated agent
 * profiles or licence numbers. Populate this array and the cards render
 * automatically.
 */
export const TEAM_MEMBERS: TeamMember[] = [];
